/*
  The benefits cards' "Read more" dialogs.

  Liquid writes each dialog in full, so this file only opens and closes them. That is the
  whole reason the article is markup rather than a JSON blob passed to a template: it is
  readable with JavaScript off, and it is one less thing to escape.

  The trigger stays an <a> with a real href. Clicking it opens the dialog and the
  navigation is suppressed; with this file absent or broken the link simply navigates,
  which is a working state rather than a dead control.

  Focus trapping, Escape, inert-ing the page behind and the backdrop all come from native
  <dialog>. The only thing added here is restoring scroll position on the document, which
  showModal() does not handle on iOS.
*/
(function () {
  'use strict';

  if (window.dpBenefitModalLoaded) return;
  window.dpBenefitModalLoaded = true;

  function init() {
    var triggers = document.querySelectorAll('[data-dp-benefit-open]');
    if (!triggers.length) return;

    var scrollY = 0;

    function open(dialog) {
      if (typeof dialog.showModal !== 'function') return false;
      scrollY = window.scrollY;
      dialog.showModal();
      // The dialog is scrollable; start every open at the top of the article rather than
      // wherever the previous one was left.
      var scroller = dialog.querySelector('.dp-benefit-modal__scroll');
      if (scroller) scroller.scrollTop = 0;
      document.body.classList.add('dp-benefit-modal-open');
      return true;
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      /* THE WHOLE CARD IS THE LINK (client, 2026-09-23). A click anywhere on a card that
         is not already on its Read more link, or on some other control, is forwarded to
         that link — which then either opens the dialog through the trigger branch below
         or navigates, exactly as if the link itself had been clicked. The link stays the
         only focusable, announced control; the card is a bigger target for it, and the
         stylesheet gives the card the hand cursor on desktop to say so. */
      var card = event.target.closest('.dp-benefit');
      if (card && !event.target.closest('a, button')) {
        var cardLink = card.querySelector('.dp-benefit__more');
        if (cardLink) {
          cardLink.click();
          return;
        }
      }

      var trigger = event.target.closest('[data-dp-benefit-open]');
      if (trigger) {
        var dialog = document.getElementById(trigger.getAttribute('data-dp-benefit-open'));
        // Only swallow the click if the dialog actually opened — otherwise let the href
        // do its job.
        if (dialog && open(dialog)) event.preventDefault();
        return;
      }

      var closer = event.target.closest('[data-dp-benefit-close]');
      if (closer) {
        var owner = closer.closest('.dp-benefit-modal');
        if (owner) owner.close();
        return;
      }

      // A click landing on the dialog element itself is the backdrop: the scroll wrapper
      // and the close button cover everything inside it.
      if (event.target.classList && event.target.classList.contains('dp-benefit-modal')) {
        event.target.close();
      }
    });

    // Covers every exit — the button, Escape, or a form method=dialog — so the class and
    // the scroll position cannot be left behind by a path this file did not anticipate.
    document.querySelectorAll('.dp-benefit-modal').forEach(function (dialog) {
      dialog.addEventListener('close', function () {
        document.body.classList.remove('dp-benefit-modal-open');
        window.scrollTo(0, scrollY);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
